import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Heading } from "../../design/heading";
import DeleteTaskButton from "./components/DeleteSubtaskButton";
import LoadingView from "../../components/LoadingView";
import ErrorView from "../../components/ErrorView";
import Breadcrumbs from "../../components/Breadcrumbs";
import { useSubtask } from "../../contexts/SubtaskContext";
import SubtaskFilesList from "./components/SubtaskFilesList/SubtaskFilesList";
import CompleteSubtaskAlert from "../../components/CompleteSubtaskAlert";
import SubtaskButton from "../../components/SubtaskButton";

const SubtaskDetailPage: React.FC = () => {
  const { subtaskId } = useParams<{ subtaskId: string }>();
  const { selectedSubtask, setSelectedSubtask, error, loading } = useSubtask();
  const [isCompleteOpen, setIsCompleteOpen] = useState(false);

  useEffect(() => {
    if (subtaskId) {
      setSelectedSubtask(subtaskId);
    }
  }, [subtaskId]);

  if (loading.details) {
    return <LoadingView />;
  }

  if (error.details) {
    return <ErrorView error={error.details} />;
  }

  if (!selectedSubtask) {
    return <ErrorView error={new Error("Subtask not found")} />;
  }

  return (
    <div>
      <Breadcrumbs
        items={[
          { label: "Tasks", href: "/tasks" },
          { label: selectedSubtask._id, href: `/task/${selectedSubtask._id}` },
        ]}
      />

      <div className="flex flex-col gap-6 lg:flex-row">
        <div className="flex flex-col w-full gap-6">
          <div className="mb-6">
            <div className="flex items-center justify-between">
              <div>
                <Heading>{selectedSubtask.title}</Heading>
                {selectedSubtask.status}
              </div>
              <div className="flex gap-2">
                <SubtaskButton subtask={selectedSubtask} />
                <DeleteTaskButton subtaskId={selectedSubtask._id} />
              </div>
            </div>
          </div>
          <CompleteSubtaskAlert
            isOpen={isCompleteOpen}
            setIsOpen={setIsCompleteOpen}
            subtaskId={selectedSubtask._id}
          />
          <SubtaskFilesList
            subtaskId={selectedSubtask._id}
            onFilesUploaded={() => setIsCompleteOpen(true)}
          />
        </div>
      </div>
    </div>
  );
};

export default SubtaskDetailPage;
